<div class="tile-head flex-row flex-vertical-center">
  <cigna-icon
    data-test="icn-messages"
    class="dashboard-icon"
    [type]="CignaIcon.EnvelopeClosed"
  ></cigna-icon>
  <h3 data-test="hdr-messages" class="cg-h3">Messages</h3>
  <div style="margin-left: auto">
    <cigna-dropdown
      type="borderless"
      [isBoldedBlue]="true"
      [value]="selectedView"
      (selectionChange)="changeMessageView($event)"
    >
      <cigna-dropdown-option data-test="cmb-all" value="all"
        >All</cigna-dropdown-option
      >
      <cigna-dropdown-option data-test="cmb-unread" value="unread"
        >Unread</cigna-dropdown-option
      >
      <!-- todo: not sure api supports this <cigna-dropdown-option value="read">Read</cigna-dropdown-option> -->
      <cigna-dropdown-option data-test="cmb-last-7-days" value="-7d"
        >Last 7 days</cigna-dropdown-option
      >
      <cigna-dropdown-option data-test="cmb-last-30-days" value="-30d"
        >Last 30 days</cigna-dropdown-option
      >
    </cigna-dropdown>
  </div>
</div>

<ng-container
  *cignaWaitToLoad="
    messages;
    let messagesData;
    errorState: error;
    loadingState: loading
  "
>
  <div *ngIf="messagesData?.length; else noMessages" class="message-list">
    <ng-container
      *ngFor="let message of messagesData; let i = index; trackBy: trackByFunc"
    >
      <cigna-message-tile-item
        [message]="message"
        [isImpersonator]="isImpersonator"
        [attr.data-test]="'message-' + i"
      >
      </cigna-message-tile-item>
    </ng-container>
  </div>
</ng-container>

<div class="footer">
  <a
    data-test="lnk-message-center"
    cignaButton="link"
    [routerLink]="['/message-center']"
    >Go to message center</a
  >
</div>

<ng-template #noMessages>
  <div class="no-messages padded" data-test="no-messages">
    <cigna-icon [type]="CignaIcon.EnvelopeOpen" class="icon"></cigna-icon>
    <div>There are no new messages.</div>
  </div>
</ng-template>

<ng-template #error let-e>
  <div
    *ngIf="e?.code || e?.status"
    data-test="error-msg"
    class="cg-error-msg-large cg-margin-bottom-lg padded"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <div data-spa-service-error>
      MCLMSGT{{ e.code ? e.code : e.status }}:
      <span> {{ e.errObject.message }} </span>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading" data-test="loading">
    <div class="cg-spinner"></div>
  </div>
</ng-template>
